// Readable labels for the end_reason codes the voice engine records.
// Unknown codes are shown as recorded.
const LABELS = {
  normal: { en: 'Ended normally', zh: '正常结束' },
  interrupted: { en: 'Interrupted', zh: '通话中断' },
  uplink_send_failed: { en: 'Audio connection lost', zh: '音频连接中断' },
  transfer_notify_missing: { en: 'Transfer not completed', zh: '转接未完成' },
};

export function callEndReasonLabel(reason, lang) {
  if (!reason) return '-';
  const label = LABELS[reason];
  return label ? label[lang === 'zh' ? 'zh' : 'en'] : reason;
}
